<template>
  <div>
    <div class="wrapper-section">
      <div class="step step-1">
        <div class="step__title">Выберите программу</div>
        <TariffInput />
        <Btn class="step__button" :disabled="!form.tariff" @click="toNextStep">Перейти к оплате</Btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from './Btn.vue'
import TariffInput from './inputs/TariffInput.vue'
export default {
  components: { TariffInput, Btn },
  data: ()=>({
    actions: {}
  }),
  computed: {
    ...mapState(['form'])
  },
  methods: {
    toNextStep(){
      if (!this.actions.step2) {
        this.actions.step2 = true
        this.$store.dispatch('callAction','step2')
      }
      this.$store.dispatch('nextStep')
    }
  },
  watch: {
    'form.tariff':function(v){
      if (v && !this.actions.tariff) {
        this.actions.tariff = true
        this.$store.dispatch('callAction','tariff')
      }
    }
  }
}
</script>

<style lang="sass">
.step
  padding-bottom: 60px
  &__title
    font-weight: 500
    font-size: 36.4px
    line-height: 1.12
    text-align: center
    color: colors.$bluefont
    margin-bottom: 32px
    @include mobFont(24, 36)
  &__button
    margin: 70px auto 0
    width: 327px
    max-width: 100%
    @include for-mob
      margin: 32px auto
</style>